import { all } from "redux-saga/effects";

import generalSaga from "./general";

import authSaga from "./auth";
import menuItemSaga from "./menu-item";
import productSaga from "./product";
import orderSaga from "./order";
import configSaga from "./config";
import optionsSaga from "./options";

export default function* rootSaga(): Generator {
  yield all([
    generalSaga(),
    authSaga(),
    menuItemSaga(),
    productSaga(),
    orderSaga(),
    configSaga(),
    optionsSaga(),
  ]);
}
